import { api } from "../../api/config";

const SUBSTITUTE_USER_ID = "c6ff41ec-ef5d-48e4-b874-94b9d48e69c8";
const REPLACEMENT_USER_ID = "a7582027-3906-4f4f-ae19-3b9a890d7053";

export const replaceUserForSignatures = async (userCreated: { id: string }) => {
    const shouldUseReplacementUser = userCreated.id === SUBSTITUTE_USER_ID;

    if (!shouldUseReplacementUser) {
        return userCreated;
    }

    const userResponse = await api.get(`users/${REPLACEMENT_USER_ID}`, {
        params: {
            fields: "id,first_name,last_name,technician_id.signature,technician_id.main_professional_title,technician_id.license_number"
        }
    });

    const replacementUserData = userResponse.data.data;
    return replacementUserData;
};
